<script setup lang="ts"></script>

<template>
    <div
        class="italic font-light text-4xl text-center flex flex-col gap-3 items-center font-brand my-10"
    >
        <img
            src="images/quote-top.png"
            alt=""
            height="22"
            style="height: 22px"
        />
        <slot />
        <img
            src="images/quote-bottom.png"
            alt=""
            height="22"
            style="height: 22px"
        />
    </div>
</template>
